import {
  LocalclassificationType, LocalclassificationState, SET_CLASSIFICATION, LocalclassificationTypes,
} from './types';

export function requestLocalClassifictations(): LocalclassificationType {
  return {
    type: LocalclassificationTypes.LOCAL_CLASSIFICATION_REQUEST,
  };
}

export function
setLocalClassifictations(payload: Array<LocalclassificationState>): LocalclassificationType {
  return {
    payload,
    type: SET_CLASSIFICATION,
  };
}
